<template>
  <div class="terminal-refund-table">
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      style="width: 100%"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
    >
      <el-table-column fixed prop="refundNum" label="退款单号" width="260" />
      <el-table-column prop="outTradeNo" label="订单编号" width="200" />
      <el-table-column prop="appName" label="来源渠道" width="250" show-overflow-tooltip />
      <el-table-column prop="openId" label="用户账号" width="150" />
      <el-table-column prop="createTime" label="申请时间" width="180" />
      
      <el-table-column label="申请金额(元)" width="120">
        <template slot-scope="scope">
          {{ (+scope.row.refundAmount) / 100 }}
        </template>
      </el-table-column>
      
      <el-table-column prop="refundApplyUser" label="申请人" width="120" />
      
      <el-table-column label="退款状态">
        <template slot-scope="scope">
          {{ getRefundStatus(scope.row.status) }}
        </template>
      </el-table-column>
      
      <el-table-column prop="refundTime" label="退款时间" width="180" />
      <el-table-column prop="refundReason" label="退款理由" width="260" show-overflow-tooltip />
      <el-table-column prop="refundHandleUser" label="处理人" width="120" />
      <el-table-column prop="handleTime" label="处理时间" width="180" />
      
      <el-table-column
        label="操作"
        fixed="right"
        width="150"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 0" 
            type="text"
            size="small"
            icon="el-icon-edit"
            @click="handleProcess(scope.row)"
            v-auth="'TERMINAL_REFUND_AUDIT'"
          >
            处理退款
          </el-button>
          <el-button
            v-if="scope.row.status !== 0"
            type="text"
            size="small"
            style="color: #67C23A"
            icon="el-icon-document"
            @click="handleDetail(scope.row)"
          >
            退款详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TerminalRefundTable',
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      refundStatusMap: {
        0: '待处理',
        1: '已退款',
        2: '退款失败',
        3: '拒绝退款',
        4: '退款中'
      }
    }
  },
  methods: {
    getRefundStatus(status) {
      return this.refundStatusMap[status] || status
    },
    handleProcess(row) {
      this.$emit('process', row)
    },
    handleDetail(row) {
      this.$emit('detail', row)
    }
  }
}
</script>
